<template>
  <div id="admin-receipt">
    <!-- 繳款項目查詢 -->
    <div
      id="areceipt"
      class="tab-pane fade show active"
      role="tabpanel"
      aria-labelledby="areceipt"
    >
      <div class="col-12 pt-2 table-style pb-4">
        <!-- 功能欄 -->
        <v-query-layout>
          <v-label
            slot="ql1-text-1"
            for="query-payon"
            LabText="查詢繳費單號："
            Labbold="true"
          />
          <input
            id="query-payon"
            class="input-style"
            type="text"
            slot="ql1-input-1"
            placeholder="請輸入關鍵字"
            v-model="PayOrderId"
          >
          <div slot="ql1-input-2">
            <v-button
              btn-text="查詢"
              btnOutline="primary"
              @click.native="InquireFeeitemQuery"
            >
              <font-awesome-icon
                slot="icon"
                icon="search"
              />
            </v-button>
            <v-button
              class="ml-2"
              btn-text="清除"
              btnOutline="secondary"
              @click.native="ClearCondition"
            >
              <font-awesome-icon
                slot="icon"
                icon="search-minus"
              />
            </v-button>
          </div>
          <v-label
            slot="ql2-text-1"
            LabText="臨櫃繳款："
            Labbold="true"
          />
          <v-button
            slot="ql2-input-1"
            btn-text="現金繳納"
            btnType="primary"
            @click.native="CheckFeeorderPaidcash"
          >
            <font-awesome-icon
              slot="icon"
              icon="hand-holding-usd"
            />
          </v-button>
          <v-label
            slot="ql2-text-2"
            for="query-page"
            LabText="筆數："
            Labbold="true"
          />
          <v-page
            slot="ql2-input-2"
            id="query-page"
            @RecPerPage="RecPerPage"
          />
        </v-query-layout>
        <hr>
        <!-- 表格資料 -->
        <template>
          <b-table
            hover
            small
            bordered
            show-empty
            stacked="md"
            empty-text="目前無資料"
            :items="items"
            :filter="filter"
            :fields="fields"
            :per-page="perPage"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :current-page="currentPage"
            :sort-direction="sortDirection"
            @filtered="onFiltered"
          >
            <!-- 流水號 -->
            <template v-slot:cell(index)="data">
              {{ data.index + 1 }}
            </template>
            <!-- 繳費金額 -->
            <template v-slot:cell(PayAmt)="data">
              {{ data.item.PayAmt + ' 元' }}
            </template>
            <!-- 繳費方式 -->
            <template v-slot:cell(PayType)="data">
              <div
                v-for="Pay in PayTypes"
                :key="Pay.id"
                :value="Pay.value"
              >
                <div v-if="Pay.value == data.item.PayType">
                  {{ Pay.text }}
                </div>
              </div>
            </template>
          </b-table>
          <!-- 總金額 -->
          <div
            class="small-color"
            style="float: right;"
          >
            總金額：{{ AllAmt + ' 元' }}
          </div>
          <!-- 分頁 -->
          <b-pagination
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            class="my-0"
          />
        </template>
      </div>
    </div>
    <!-- 現金繳納 modal -->
    <v-modal id="FeeorderPaidcash">
      <div slot="header">
        現金繳納
      </div>
      <div slot="body">
        <div class="form-group">
          <label
            for="ReceiptTitle"
            class="col-form-label"
          >
            收據抬頭:
          </label>
          <input
            id="ReceiptTitle"
            class="input-style ml-2 nukWord"
            type="text"
            v-model="Paidcash.ReceiptTitle"
          >
          <label
            for="addUserName"
            class="col-form-label ml-2 mr-1"
          >
            同繳款人姓名
          </label>
          <input
            id="addUserName"
            type="checkbox"
            v-model="UserName"
            :true-value="1"
            :false-value="2"
            @click="CheckUser"
          >
        </div>
        <div class="form-group">
          <label
            for="CompanyTaxId"
            class="col-form-label"
          >
            公司統編:
          </label>
          <input
            id="CompanyTaxId"
            class="input-style ml-2"
            type="text"
            v-model="Paidcash.CompanyTaxId"
          >
        </div>
        <div class="form-group">
          <label
            for="PayOrderId"
            class="col-form-label"
          >
            繳費單號:
          </label>
          <input
            id="PayOrderId"
            class="input-style ml-2"
            type="text"
            v-model="PayOrderId"
            disabled
          >
        </div>
        <div class="form-group">
          <label
            for="TotalAmt"
            class="col-form-label"
          >
            繳費單號總金額:
          </label>
          <input
            id="TotalAmt"
            class="input-style ml-2"
            type="text"
            v-model.number="AllAmt"
            disabled
          >
        </div>
      </div>
      <div slot="footer">
        <v-button
          btn-text="新增"
          btnType="primary"
          @click.native="PostFeeorderPaidcash"
        />
        <v-button
          class="ml-1"
          btn-text="取消"
          btnType="secondary"
          data-dismiss="modal"
          aria-label="Close"
        />
      </div>
    </v-modal>
  </div>
</template>

<script>
import $ from 'jquery'
import vLabel from '@/components/Features/Label'
import vModal from '@/components/Features/ModalFloot'
import vQueryLayout from '@/components/Layout/QueryLayout'
import { apiFeeorderQuerypayorder, apiFeeorderPaidcash } from '../../../Api/api'
export default {
  components: {
    'v-modal': vModal,
    'v-label': vLabel,
    'v-query-layout': vQueryLayout
  },
  name: 'receipt',
  data () {
    return {
      items: [],
      fields: [
        { key: 'index', label: '#', thClass: 'table-th', variant: 'info' },
        { key: 'PayType', label: '繳費方式', thClass: 'table-th', sortable: true },
        { key: 'FeeOrderId', label: '繳款項目編號', thClass: 'table-th' },
        { key: 'FeeItemName', label: '收費項目名稱', thClass: 'table-th' },
        { key: 'FeeOrderDesc', label: '事由', thClass: 'table-th' },
        { key: 'PayAmt', label: '繳費金額', thClass: 'table-th', sortable: true, variant: 'warning' },
        { key: 'PayDateEnd', label: '繳費期限截止', thClass: 'table-th', class: 'table-long' }
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      sortBy: null,
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      PayOrderId: null,
      AllAmt: 0,
      Paidcash: {
        ReceiptTitle: '',
        CompanyTaxId: '',
        PayOrderId: '',
        Data: []
      },
      PayName: '',
      PayTypes: [
        { value: '0', text: '未繳費' },
        { value: '253', text: '有跳轉WebATM' },
        { value: '254', text: '列印繳費單(無條碼)' },
        { value: '255', text: '列印繳費單(有條碼)' }
      ],
      UserName: false
    }
  },
  computed: {
    sortOptions () {
      return this.fields
        .filter(f => f.sortable)
        .map(f => {
          return { text: f.label, value: f.key }
        })
    }
  },
  mounted () {
    this.PostFeeorderQuerypayorder()
  },
  methods: {
    RecPerPage (SublayerPage) { // 組件筆數
      this.perPage = SublayerPage
    },
    onFiltered (filteredItems) {
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    PostFeeorderQuerypayorder () { // 查詢繳費單號 B_API 012
      // 定義資料
      const vm = this
      vm.AllAmt = 0 // 金額歸零
      vm.Paidcash.PayOrderId = vm.PayOrderId
      const NewData = JSON.parse(sessionStorage.getItem('Identity'))
      const ReceiptQuery = sessionStorage.getItem('ReceiptQuery')
      if (!ReceiptQuery) {
        vm.items = []
        return false
      } else {
        vm.PayOrderId = ReceiptQuery
        NewData.PayOrderId = ReceiptQuery
      }
      // 呼叫API
      apiFeeorderQuerypayorder(NewData).then(
        res => {
          if (res !== undefined) {
            vm.items = res.Data
            vm.PayName = res.Data[0].UserName
            const AmtData = res.Data
            for (let index = 0; index < AmtData.length; index++) {
              vm.AllAmt += AmtData[index].PayAmt
            }
          } else {
            $('#CheckError').modal('show')
          }
        }
      )
    },
    InquireFeeitemQuery () { // 查詢條件
      // 定義資料
      const vm = this
      const NewData = JSON.parse(sessionStorage.getItem('Identity'))
      if (!vm.PayOrderId) {
        return false
      }
      NewData.PayOrderId = vm.PayOrderId
      // 紀錄查詢條件
      sessionStorage.setItem('ReceiptQuery', vm.PayOrderId)
      // 呼叫API
      apiFeeorderQuerypayorder(NewData).then(
        res => {
          if (res !== undefined) {
            vm.items = res.Data
            vm.PayName = res.Data[0].UserName
            const AmtData = res.Data
            for (let index = 0; index < AmtData.length; index++) {
              vm.AllAmt += AmtData[index].PayAmt
            }
          } else {
            $('#CheckError').modal('show')
          }
        }
      )
    },
    ClearCondition () { // 清除查詢條件
      const vm = this
      sessionStorage.removeItem('ReceiptQuery')
      vm.PayOrderId = null
      vm.items = []
      vm.PostFeeorderQuerypayorder()
    },
    CheckUser () {
      const vm = this
      if (vm.UserName === 1) {
        vm.Paidcash.ReceiptTitle = ''
      } else {
        vm.Paidcash.ReceiptTitle = vm.PayName
      }
    },
    CheckFeeorderPaidcash () { // 準備現金繳納
      if (this.PayOrderId === null) {
        this.$bus.$emit('Modals', '無繳費單號。')
        $('#CheckError').modal('show')
        return false
      }
      $('#FeeorderPaidcash').modal('show')
    },
    PostFeeorderPaidcash () { // 現金繳納 B_API 013
      // 定義資料
      const vm = this
      $('#FeeorderPaidcash').modal('hide')
      const Identitys = JSON.parse(sessionStorage.getItem('Identity'))
      for (let i = 0; i < vm.items.length; i++) {
        vm.Paidcash.Data[i] = {}
        vm.Paidcash.Data[i].FeeOrderId = vm.items[i].FeeOrderId
        vm.Paidcash.Data[i].PayAmt = vm.items[i].PayAmt
      }
      const NewData = Object.assign(Identitys, vm.Paidcash)
      delete NewData.ApplyDeptId
      NewData.PayOrderId = vm.PayOrderId
      NewData.TotalAmt = vm.AllAmt
      // 呼叫API
      apiFeeorderPaidcash(NewData).then(
        res => {
          if (res !== undefined) {
            vm.$bus.$emit('Modals', '繳納成功。')
            $('#CheckOk').modal('show')
            vm.ClearCondition()
          } else {
            $('#CheckError').modal('show')
          }
        }
      )
    }
  }
}
</script>
